import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { BehaviorSubject, Observable } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class ImpersonationService {
  private readonly _impersonatedUserId$: BehaviorSubject<string | undefined>;
  private readonly _impersonatedUserIdKey = 'tcs-impersonated-user-id';
  get impersonatedUserId(): string | undefined {
    return this._impersonatedUserId$.getValue();
  }
  get impersonatedUserId$(): Observable<string | undefined> {
    return this._impersonatedUserId$.asObservable();
  }
  constructor(private _router: Router) {
    const userId = localStorage.getItem(this._impersonatedUserIdKey);
    this._impersonatedUserId$ = new BehaviorSubject<string | undefined>(userId ?? undefined);
  }

  public impersonateUser(userId: string) {
    localStorage.setItem(this._impersonatedUserIdKey, userId);
    this._impersonatedUserId$.next(userId);
    this._router.navigate(['/']);
  }
  public stopImpersonating() {
    this.clearImpersonation();
    this._router.navigate(['/']);
  }
  public clearImpersonation() {
    localStorage.removeItem(this._impersonatedUserIdKey);
    this._impersonatedUserId$.next(undefined);
  }
}
